let rest = require('rest');
let mime = require('rest/interceptor/mime');
import restInterceptor from './restRetryInterceptor';

let client = rest.wrap(mime, { mime: 'application/json' }).wrap(restInterceptor);
const handledClient = (...args) => {
  return client(...args)
    .then((x) => {
      if (x.status.code < 300 && x.status.code >= 200) {
          return x;
      }

      throw x;
    })
    .catch((err) => {
      throw err;
    });
};

export default handledClient;

export const clientTransformed = (...args) => {
  return handledClient(...args)
    .then((x) => {
      if (typeof x.entity?.code === 'number' && x.entity?.code >= 400) {
        const errors = x.entity?.errors || ['Operation failed'];

        throw {
          entity: errors[0],
        };
      }

      const isNewStructure = x.entity?.hasOwnProperty('data') && x.entity?.hasOwnProperty('code') && x.entity?.hasOwnProperty('errors');

      if (isNewStructure) {
        x.entity = x.entity.data;

        return x;
      }
    })
    .catch((err) => {
      throw err;
    });
};

export const getErrorText = (possibleText, defaultText = 'Something went wrong') => {
  return typeof possibleText === 'string' ? possibleText : defaultText;
};